/* toki-sponsored-wheel.part5.js — boot only the sponsored mount; no main wheel globals touched */
(function(){
  'use strict';
  var W=window.TokiSponsoredWheelEngine;
  if(!W||W.__part5Loaded) return;
  W.__part5Loaded=true;

  function mountAll(){
    Array.prototype.slice.call(document.querySelectorAll('[data-toki-sponsored-wheel="grit-goo"]')).forEach(function(host){
      var inst=W.create(host); if(!inst) return;
      W.buildUI(inst); W.renderWheel(inst); W.bind(inst);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mountAll); else mountAll();
})();
